module.exports = __webpack_public_path__ + "static/media/19.40a3f53e.JPG";